import { ApiOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/openPlatform',
    name: 'openPlatform',
    redirect: '/openPlatform/app',
    meta: {
      title: '开放平台',
      sort: 7,
      icon: ApiOutlined,
      isFullScreen: false,
      keepAlive: true,
      hidden: false,
      prem: true,
    },
    children: [
      {
        path: '/openPlatform/app',
        name: 'openPlatformApp',
        component: () => import('@/views/system/openApp/index.vue'),
        meta: {
          title: '开放应用',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/openPlatform/api',
        name: 'openPlatformApi',
        component: () => import('@/views/system/openApi/index.vue'),
        meta: {
          title: '授权接口',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/openPlatform/log',
        name: 'openPlatformLog',
        component: () => import('@/views/system/openLog/index.vue'),
        meta: {
          title: '调用日志',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/openPlatform/pushLog',
        name: 'openPlatformPushLog',
        component: () => import('@/views/system/openPushLog/index.vue'),
        meta: {
          title: '推送日志',
          sort: 4,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
